export default () => ({
    products:[],
    product_categories:[],
    variants:[],
    addVariants:[],
    employee_inventories:[],
});
